import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import NotificationWindow from "../../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import UniversalModal from "../../universalModal";

import { countriesData, headerName } from "./constantsCountriesModal";

import styles from "./countriesModal.module.css";
import { CHANGE_COUNTRIES_IS_SAVE, GET_COUNTRIES_NO_ERROR } from "../../../../../redux/types";
import {
  createCountry,
  updateCountry,
} from "../../../../../redux/directoryMaintenance/countriesReducer/actionsCountries";

export default function CountriesModal({ setShow, show, type, setSave }) {
  const dispatch = useDispatch();
  const [initialFieldsData, setInitialFieldsData] = useState({});
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);

  const countriesReducer = useSelector((state) => state.countriesReducer);

  const handleSaveClick = async (data) => {
    console.log(data);
    if (type === "add") {
      dispatch(createCountry(data, countriesReducer.searchParams));
      return false;
    }
    if (type === "edit") {
      const changedValues = {};
      for (let key in data) {
        if (data[key] !== countriesReducer.country[key]) {
          changedValues[key] = data[key];
        }
      }
      dispatch(updateCountry(countriesReducer.country.id, changedValues, countriesReducer.searchParams));
      return false;
    }
  };

  const handleOnHide = () => {
    setShow(false);
    dispatch({
      type: GET_COUNTRIES_NO_ERROR,
      data: "",
    });
    dispatch({
      type: CHANGE_COUNTRIES_IS_SAVE,
    });
  };

  useEffect(() => {
    if (countriesReducer.error !== "") {
      setShowNotificationWindow(!showNotificationWindow);
    }
  }, [countriesReducer.error]);

  return (
    <>
      <UniversalModal
        show={show}
        onHide={() => handleOnHide()}
        onSave={(data) => handleSaveClick(data)}
        fields={Object.values(countriesData)}
        initialFieldsData={initialFieldsData}
        initialData={{ ...countriesReducer.country }}
        headerName={headerName[type]}
        type={type}
        size="lg"
        stylesFromParent={styles}
      />
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        onClose={() => {
          if (countriesReducer.isSave) {
            handleOnHide();
          }
          if (!countriesReducer.isSave) {
            setShowNotificationWindow(!showNotificationWindow);
            dispatch({ type: CHANGE_COUNTRIES_IS_SAVE });
          }
        }}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={countriesReducer.error}
      />
    </>
  );
}
